<template>
  <el-pagination
    v-if="totalDeRegistros > 0"
    @size-change="$emit('tamanhoPaginaMudou', $event)"
    @current-change="$emit('paginaMudou', $event)"
    :page-sizes="[25, 50, 75, 100]"
    :page-size="pageSize"
    :current-page="page"
    layout="sizes, prev, pager, next"
    background
    class="text-center"
    :total="totalDeRegistros"
  />
</template>

<script>
export default {
  props: {
    page: Number,
    pageSize: Number,
    totalDeRegistros: Number
  }
};
</script>
